
/*
 * ETERNAL BLOOM — GIFT SERVICES
 * Complimentary personalized gift note.
 * Saves order-level Shopify cart attributes.
 */

(() => {
  
  const rootSelector = ".eb-gift-services";
  const keys = {
    requested: "EB Gift Note Requested",
    recipient: "EB Gift Recipient",
    message: "EB Gift Message"
  };

  let saving = Promise.resolve();

  const cartUrl = (path) =>
    `${window.Shopify?.routes?.root || "/"}${path}`;

  async function updateAttributes(attributes) {
    const response = await fetch(cartUrl("cart/update.js"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes })
    });

    if (!response.ok) {
      throw new Error("Unable to save gift details.");
    }

    return response.json();
  }

  function initialize(root) {
    if (root.dataset.ebGiftInitialized === "true") return;
    root.dataset.ebGiftInitialized = "true";

    const toggle = root.querySelector('[data-eb-gift="toggle"]');
    const fields = root.querySelector('[data-eb-gift="fields"]');
    const recipient = root.querySelector('[data-eb-gift="recipient"]');
    const message = root.querySelector('[data-eb-gift="message"]');
    const counter = root.querySelector('[data-eb-gift="counter"]');

    function updateCounter() {
    if (!message || !counter) return;

    if (message.value.length > 150) {
        message.value = message.value.slice(0, 150);
    }

    counter.textContent = `${message.value.length} / 150`;
    }
    const form = root.closest("form");
    const checkout = form?.querySelector('[name="checkout"]');

    if (!toggle || !fields || !recipient || !message) return;

    const status = document.createElement("p");
    status.setAttribute("role", "status");
    status.setAttribute("aria-live", "polite");
    status.style.fontSize = "12px";
    root.appendChild(status);

    const syncVisibility = () => {
      fields.hidden = !toggle.checked;
    };

    function save() {
      const attributes = {
        [keys.requested]: toggle.checked ? "Yes" : "",
        [keys.recipient]: toggle.checked ? recipient.value.trim() : "",
        [keys.message]: toggle.checked ? message.value.trim().slice(0, 150) : ""
      };

      status.textContent = "Saving gift details…";

      saving = saving.catch(() => {}).then(async () => {
        await updateAttributes(attributes);
        status.textContent = "Gift details saved.";
      }).catch((error) => {
        status.textContent = "Could not save gift details. Please try again.";
        throw error;
      });

      // Prevent an unhandled rejection until the next operation.
      saving.catch(() => {});
    }

    toggle.addEventListener("change", () => {
        if (!toggle.checked) {
            recipient.value = "";
            message.value = "";
        }

        syncVisibility();
        save();
    });

    recipient.addEventListener("change", save);
    message.addEventListener("input", updateCounter);
    message.addEventListener("change", () => {
    updateCounter();
    save();
    });

    updateCounter();


    form?.addEventListener("submit", async (event) => {
      if (!event.submitter || event.submitter.name !== "checkout") return;

      event.preventDefault();

      if (checkout) checkout.disabled = true;

      try {
        await saving;
        await updateAttributes({
          [keys.requested]: toggle.checked ? "Yes" : "",
          [keys.recipient]: toggle.checked ? recipient.value.trim() : "",
          [keys.message]: toggle.checked ? message.value.trim().slice(0, 150) : ""
        });

        window.location.assign(cartUrl("checkout"));
      } catch (error) {
        status.textContent =
          "Gift details could not be saved. Please try checkout again.";
        if (checkout) checkout.disabled = false;
      }
    });

    syncVisibility();
  }

  function initializeAll() {
    document.querySelectorAll(rootSelector).forEach(initialize);
  }

  document.addEventListener("DOMContentLoaded", initializeAll);

  new MutationObserver(initializeAll).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  initializeAll();
})();
